import { render, staticRenderFns } from "./pane-tag.vue?vue&type=template&id=70232d00&scoped=true&"
import script from "./pane-tag.vue?vue&type=script&lang=js&"
export * from "./pane-tag.vue?vue&type=script&lang=js&"
import style0 from "./pane-tag.vue?vue&type=style&index=0&id=70232d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70232d00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('70232d00', component.options)
    } else {
      api.reload('70232d00', component.options)
    }
    module.hot.accept("./pane-tag.vue?vue&type=template&id=70232d00&scoped=true&", function () {
      api.rerender('70232d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/render_custom_plugin/pane-tag.vue"
export default component.exports